"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return DataReflection;
    }
});
const _extractProps = require("~/helpers/extractProps");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _dataReflectionHelpers = require("~/helpers/dataReflectionHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let DataReflection = class DataReflection {
    static async init() {}
    static async insert(dataReflection, ncMeta = _Noco.default.ncMeta) {
        const insertData = (0, _extractProps.extractProps)(dataReflection, [
            'fk_workspace_id',
            'username',
            'password',
            'database'
        ]);
        const insertedDataReflection = await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.DATA_REFLECTION, insertData);
        return this.get({
            id: insertedDataReflection.id
        });
    }
    static async get(params, ncMeta = _Noco.default.ncMeta) {
        const condition = (0, _extractProps.extractProps)(params, [
            'id',
            'fk_workspace_id'
        ]);
        if (!condition.id && !condition.fk_workspace_id) {
            _catchError.NcError.badRequest('id or fk_workspace_id is required');
        }
        let dataReflection = condition.id ? await _NocoCache.default.get('root', `${_globals.CacheScope.DATA_REFLECTION}:${condition.id}`, _globals.CacheGetType.TYPE_OBJECT) : condition.fk_workspace_id ? await _NocoCache.default.get('root', `${_globals.CacheScope.DATA_REFLECTION}:${condition.fk_workspace_id}`, _globals.CacheGetType.TYPE_OBJECT) : null;
        if (!dataReflection) {
            dataReflection = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.DATA_REFLECTION, condition);
            if (!dataReflection) {
                return null;
            }
            dataReflection.host = _dataReflectionHelpers.NC_DATA_REFLECTION_SETTINGS.host;
            dataReflection.port = _dataReflectionHelpers.NC_DATA_REFLECTION_SETTINGS.port;
            if (dataReflection) {
                await _NocoCache.default.set('root', `${_globals.CacheScope.DATA_REFLECTION}:${dataReflection.id}`, dataReflection);
                await _NocoCache.default.set('root', `${_globals.CacheScope.DATA_REFLECTION}:${dataReflection.fk_workspace_id}`, dataReflection);
            }
        }
        return new DataReflection(dataReflection);
    }
    static async delete(params, ncMeta = _Noco.default.ncMeta) {
        const condition = (0, _extractProps.extractProps)(params, [
            'id',
            'fk_workspace_id'
        ]);
        if (!condition.id && !condition.fk_workspace_id) {
            _catchError.NcError.badRequest('id or fk_workspace_id is required');
        }
        const dataReflection = await this.get(condition, ncMeta);
        if (!dataReflection) {
            return;
        }
        await _NocoCache.default.del('root', `${_globals.CacheScope.DATA_REFLECTION}:${dataReflection.id}`);
        await _NocoCache.default.del('root', `${_globals.CacheScope.DATA_REFLECTION}:${dataReflection.fk_workspace_id}`);
        await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.DATA_REFLECTION, condition);
    }
    static async availableSchemas(fk_workspace_id, ncMeta = _Noco.default.ncMeta) {
        const data = await _models.Base.list(fk_workspace_id, ncMeta);
        return data.map((base)=>base.id);
    }
    static async create(fk_workspace_id, _ncMeta = _Noco.default.ncMeta) {
        _catchError.NcError.notImplemented('Data Reflection');
    }
    static async destroy(fk_workspace_id, _ncMeta = _Noco.default.ncMeta) {
        return;
    }
    static async grantBase(fk_workspace_id, base_id, _ncMeta = _Noco.default.ncMeta) {
        return;
    }
    static async revokeBase(fk_workspace_id, base_id, _ncMeta = _Noco.default.ncMeta) {
        return;
    }
    constructor(dataReflection){
        Object.assign(this, dataReflection);
    }
};
